export const isIOSDevice = () =>
  /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const waitForActiveServiceWorker = async registration => {
  if (registration.active?.state === "activated") return registration;
  const worker = registration.installing || registration.waiting || registration.active;
  if (!worker) throw new Error("No se encontró el servicio de notificaciones.");

  await new Promise((resolve, reject) => {
    const finish = error => {
      window.clearTimeout(timer);
      worker.removeEventListener("statechange", checkState);
      if (error) reject(error);
      else resolve();
    };
    const checkState = () => {
      if (worker.state === "activated") finish();
      else if (worker.state === "redundant") finish(new Error("No se pudo activar el servicio de notificaciones."));
    };
    const timer = window.setTimeout(() => finish(new Error("El servicio de notificaciones tardó demasiado en activarse.")), 15000);
    worker.addEventListener("statechange", checkState);
    checkState();
  });
  return registration;
};
